import { NavLink } from 'react-router-dom';
import tyrlLogo from '../../assets/tyrl-logo.svg';
import { Inbox, Send, TrendingUp, X } from 'lucide-react';

type Item = { to: string; label: string; icon: React.ReactNode; color: string };

// Two items, so the group headings that used to separate the audit from the
// pipeline would say nothing. Flat list (TYR-216).
const items: Item[] = [
  { to: '/internal/leads', label: 'Client scans', icon: <Inbox size={16} />, color: 'text-grow' },
  { to: '/internal/hub-access', label: 'Hub Access', icon: <Send size={16} />, color: 'text-grow' },
];

type Props = {
  mobileOpen?: boolean;
  onClose?: () => void;
};

export function Sidebar({ mobileOpen, onClose }: Props) {
  return (
    <aside
      className={`w-60 bg-surface-1 border-r border-border flex flex-col z-40 transition-transform duration-200 md:translate-x-0 md:static md:flex
        fixed inset-y-0 left-0 ${mobileOpen ? 'translate-x-0' : '-translate-x-full'}`}
    >
      <div className="p-5 border-b border-border flex items-center gap-2.5">
        <img src={tyrlLogo} alt="TYRL" className="h-4 opacity-90 brightness-0 invert" />
        <span className="text-[11px] uppercase tracking-[0.14em] text-neutral-500">OrgIQ</span>
        <TrendingUp size={14} className="text-grow ml-auto" />
        {onClose ? (
          <button
            type="button"
            aria-label="Close navigation"
            onClick={onClose}
            className="md:hidden text-neutral-500 hover:text-crux-light p-1 -m-1"
          >
            <X size={16} />
          </button>
        ) : null}
      </div>
      <nav className="flex-1 py-3 overflow-y-auto">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              [
                'flex items-center gap-2 px-5 py-2 text-sm transition-colors',
                isActive
                  ? 'bg-surface-3 text-crux-light border-l-2 border-grow'
                  : 'text-neutral-400 hover:text-crux-light hover:bg-surface-2',
              ].join(' ')
            }
          >
            <span className={item.color}>{item.icon}</span>
            <span className="flex-1">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
